import React from "react";

const FormError = ({ children }) => (
  <div className="text-red-brand text-sm my-2">{children}</div>
);

export default FormError;
